export default "__VITE_ASSET__QHa0TKK5__"